(function () {
  'use strict';

  function createGrouper(perPage) {
    var reps = [];
    var seen = new Set();
    var extras = [];
    return {
      add: function (item) {
        if (item.key != null) {
          if (!seen.has(item.key)) {
            seen.add(item.key);
            reps.push(item);
          }
        } else {
          extras.push({ at: Math.floor(reps.length / perPage), item: item });
        }
      },
      enough: function (g) {
        return reps.length > g * perPage;
      },
      page: function (g, exhausted) {
        var last = Math.max(1, Math.ceil(reps.length / perPage));
        if (exhausted && g > last) g = last;
        return {
          g: g,
          cards: reps.slice((g - 1) * perPage, g * perPage),
          extras: extras.filter(function (extra) {
            return (exhausted ? Math.min(extra.at, last - 1) : extra.at) === g - 1;
          }).map(function (extra) { return extra.item; }),
          hasPrev: g > 1,
          hasNext: reps.length > g * perPage
        };
      },
      size: function () { return reps.length; }
    };
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { createGrouper: createGrouper };
    return;
  }

  function itemFrom(el) {
    return { key: el.dataset.pvKey, id: el.dataset.pvId, type: el.dataset.pvType, el: el };
  }

  async function run() {
    var grid = document.querySelector('[data-pv-group]');
    if (!grid) return;
    var section = grid.closest('.shopify-section');
    var sectionId = section.id.replace(/^shopify-section-/, '');
    var perPage = parseInt(grid.dataset.pvGroup, 10);
    var rawPages = parseInt(grid.dataset.pvPages, 10) || 1;
    var params = new URLSearchParams(location.search);
    var g = Math.max(1, parseInt(params.get('gpage') || params.get('page') || '1', 10) || 1);
    var rawPage = parseInt(params.get('page') || '1', 10) || 1;
    var nav = section.querySelector('[data-pv-pagination]');
    var domCards = Array.from(grid.children);
    var domById = new Map(domCards.map(function (el) { return [el.dataset.pvId, el]; }));
    var rawNav = nav ? Array.from(nav.childNodes) : [];
    var rawFooter = section.querySelector('.productgrid--footer');
    var footerParent = rawFooter && rawFooter.parentNode;
    var footerNext = rawFooter && rawFooter.nextSibling;
    var newFooter;

    function href(n) {
      var url = new URL(location.href);
      url.searchParams.delete('page');
      url.searchParams.delete('gpage');
      if (n !== 1) url.searchParams.set('gpage', n);
      return url.pathname + url.search + url.hash;
    }

    // A new sort starts at grouped page 1. Empire's sort handler rebuilds the URL from location
    // (FacetedFilterCollection._changeSorting), so drop page/gpage first; capture runs before it.
    // Filters and searches already build URLs without gpage.
    function resetOnSort(event) {
      var selector = event.type === 'change' ? '[data-productgrid-trigger-sort]' : '[data-productgrid-trigger-sort-button]';
      if (event.target.closest && event.target.closest(selector)) history.replaceState(history.state, '', href(1));
    }
    document.addEventListener('change', resetOnSort, true);
    document.addEventListener('click', resetOnSort, true);

    try {
      if (g === 1 && rawPage === 1) {
        var seen = new Set();
        domCards.forEach(function (el) {
          var key = el.dataset.pvKey;
          if (key == null) return;
          if (seen.has(key)) el.remove();
          else seen.add(key);
        });
      } else {
        grid.style.visibility = 'hidden';
      }
      grid.setAttribute('aria-busy', 'true');
      if (nav) nav.hidden = true;

      var grouper = createGrouper(perPage);
      var exhausted = false;
      var fetched = false;
      if (rawPages === 1 && rawPage === 1) {
        domCards.forEach(function (el) { grouper.add(itemFrom(el)); });
        exhausted = true;
      } else {
        fetched = true;
        // ponytail: sequential fetches cost ~g*perPage*dupRatio/48 round trips; parallelize if that matters.
        for (var k = 1; ; k += 1) {
          var streamParams = new URLSearchParams(params);
          streamParams.delete('gpage');
          streamParams.set('page', k);
          streamParams.set('section_id', 'pv-grid-stream');
          var controller = new AbortController();
          var timeout = setTimeout(function () { controller.abort(); }, 10000);
          var doc;
          try {
            var res = await fetch(location.pathname + '?' + streamParams.toString(), {
              credentials: 'same-origin', signal: controller.signal
            });
            if (!res.ok) throw new Error('Stream HTTP ' + res.status);
            doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          } finally {
            clearTimeout(timeout);
          }
          var stream = doc.querySelector('[data-pv-stream]');
          if (!stream) throw new Error('Missing pv-grid-stream section');
          Array.from(stream.children).forEach(function (el) { grouper.add(itemFrom(el)); });
          var pages = parseInt(stream.dataset.pvPages, 10) || 1;
          if (k >= pages) { exhausted = true; break; }
          if (grouper.enough(g)) break;
        }
      }

      var p = grouper.page(g, exhausted);
      grid.replaceChildren(...p.cards.map(function (card) { return domById.get(card.id) || card.el; }));

      if (grid.hasAttribute('data-pv-footer') && fetched) {
        if (rawFooter) rawFooter.remove();
        if (p.extras.length) {
          newFooter = document.createElement('div');
          newFooter.className = 'productgrid--footer';
          ['article', 'page'].forEach(function (type) {
            var items = p.extras.filter(function (item) { return item.type === type; });
            if (!items.length) return;
            var group = document.createElement('div');
            group.className = 'productgrid--footer-item';
            var title = document.createElement('h2');
            title.className = 'productgrid--footer-title';
            title.textContent = type === 'article' ? grid.dataset.pvPostsTitle : grid.dataset.pvPagesTitle;
            var list = document.createElement('ul');
            list.className = 'productgrid--footer-results-list';
            items.forEach(function (item) { list.appendChild(item.el); });
            group.appendChild(title);
            group.appendChild(list);
            newFooter.appendChild(group);
          });
          if (nav) nav.parentNode.insertBefore(newFooter, nav);
          else grid.closest('.productgrid--wrapper').appendChild(newFooter);
        }
      }

      if (nav) {
        nav.replaceChildren();
        if (p.hasPrev || p.hasNext) {
          var pagination = document.createElement('nav');
          pagination.className = 'pagination--container';
          pagination.setAttribute('aria-label', 'Pagination');
          var inner = document.createElement('ul');
          inner.className = 'pagination--inner';
          var chevron = section.querySelector('template[data-pv-chevron]');
          function addLink(previous) {
            var li = document.createElement('li');
            li.className = previous ? 'pagination--previous' : 'pagination--next';
            var link = document.createElement('a');
            link.className = 'pagination--item';
            link.href = href(p.g + (previous ? -1 : 1));
            link.setAttribute('aria-label', previous ? 'Go to previous page' : 'Go to next page');
            var icon = document.createElement('span');
            icon.className = previous ? 'pagination--chevron-left' : 'pagination--chevron-right';
            icon.setAttribute('aria-hidden', 'true');
            icon.innerHTML = chevron ? chevron.innerHTML : '';
            var label = document.createTextNode(previous ? grid.dataset.pvPrev : grid.dataset.pvNext);
            link.appendChild(previous ? icon : label);
            link.appendChild(previous ? label : icon);
            li.appendChild(link);
            inner.appendChild(li);
          }
          if (p.hasPrev) addLink(true);
          var current = document.createElement('li');
          current.className = 'pagination--active';
          current.setAttribute('aria-current', 'true');
          current.setAttribute('aria-label', 'Page ' + p.g);
          var number = document.createElement('span');
          number.className = 'pagination--item';
          number.textContent = p.g;
          current.appendChild(number);
          inner.appendChild(current);
          if (p.hasNext) addLink(false);
          pagination.appendChild(inner);
          nav.appendChild(pagination);
          nav.hidden = false;
        }
      }
      if (p.g !== g) history.replaceState(null, '', href(p.g));
      grid.removeAttribute('aria-busy');
      grid.style.visibility = '';
      if (p.cards.some(function (card) { return !domById.has(card.id); })) {
        // Empire's Sections manager and rimg handle these theme-editor events.
        // If empire.js has not initialized yet, it will bind to the final DOM instead.
        section.dispatchEvent(new CustomEvent('shopify:section:unload', { bubbles: true, detail: { sectionId: sectionId } }));
        section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sectionId } }));
      }
    } catch (err) {
      console.warn('pv-grid-group', err);
      grid.replaceChildren(...domCards);
      if (nav) { nav.replaceChildren(...rawNav); nav.hidden = false; }
      if (newFooter) newFooter.remove();
      if (rawFooter && !rawFooter.parentNode) footerParent.insertBefore(rawFooter, footerNext);
      grid.removeAttribute('aria-busy');
      grid.style.visibility = '';
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
